/**
 * Search results reducer
 * @module src/reducers/getSearchFiltersReducer
 */

import { GET_SEARCH_RESULTS } from '@redturtle/iovisit-theme/actions/searchResults';

const initialState = {
  error: null,
  hasError: false,
  result: {},
  loading: false,
};

export const searchResultsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_SEARCH_RESULTS}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
      };

    case `${GET_SEARCH_RESULTS}_SUCCESS`:
      return {
        ...state,
        result: action.result,
        loading: false,
        loaded: true,
      };

    case `${GET_SEARCH_RESULTS}_FAIL`:
      return {
        ...state,
        error: action.error,
        hasError: true,
        loading: false,
        loaded: false,
      };

    default:
      return state;
  }
};
